import React, { useState } from 'react';
import {
  Form,
  Select,
  Button,
} from 'antd';
import firebase from 'firebase';

import { FormItemLayout, TailFormItemLayout } from '../../utils/Constants';
import { getAppBaseUrl } from '../../utils/URLBuilder';
const { Option } = Select;

// TrueLayer provider strings by country code.
// Countries not listed here have no TrueLayer coverage — manual IBAN entry only.
export const TRUELAYER_PROVIDERS = {
  'AT': 'at-ob-all',
  'BE': 'be-ob-all',
  'DE': 'de-ob-all',
  'DK': 'dk-ob-all',
  'EE': 'ee-oauth-all',
  'ES': 'es-ob-all',
  'FI': 'fi-ob-all',
  'FR': 'fr-ob-all',
  'GB': 'uk-ob-all uk-oauth-all',
  'IE': 'ie-ob-all',
  'IT': 'it-ob-all',
  'LT': 'lt-oauth-all',
  'LV': 'lv-oauth-all',
  'NL': 'nl-ob-all',
  'NO': 'no-ob-all',
  'PL': 'pl-ob-all',
  'PT': 'pt-ob-all',
  'SE': 'se-ob-all',
};

// All SEPA countries with TrueLayer support (subset of full SEPA list)
export const truelayerCountries = Object.keys(TRUELAYER_PROVIDERS);

const countryByCountryCode = {
  'AT': 'Austria',
  'BE': 'Belgium',
  'DE': 'Germany',
  'DK': 'Denmark',
  'EE': 'Estonia',
  'ES': 'Spain',
  'FI': 'Finland',
  'FR': 'France',
  'GB': 'United Kingdom',
  'IE': 'Ireland',
  'IT': 'Italy',
  'LT': 'Lithuania',
  'LV': 'Latvia',
  'NL': 'Netherlands',
  'NO': 'Norway',
  'PL': 'Poland',
  'PT': 'Portugal',
  'SE': 'Sweden',
};

const sampleBanks = {
  US: 'Revolut, BofA, Chase, etc.',
  UK: 'Revolut, Lloyds, RBS, Monzo, etc.',
  IE: 'Revolut, AIB, Bank of Ireland, AIB, N26, etc.',
  LT: 'Revolut',
};

export const InitiateTrueLayerForm = ({ bank, clientId }) => {
  const isLocalHost = window.location.hostname === 'localhost';
  const [form] = Form.useForm();
  const [selectedCountry, setSelectedCountry] = useState(bank && bank.country ? bank.country : "IE");

  const onSelectCountry = (value) => {
    setSelectedCountry(value);
  };

  const db = firebase.firestore();

    const baseUrl = isLocalHost ? 'auth.truelayer-sandbox.com' : 'auth.truelayer.com';
    const tlClientId = isLocalHost ?  'sandbox-strikepay-eaf425' : 'strikepay-eaf425';
    const strikeBaseUrl = getAppBaseUrl();
    let providers = TRUELAYER_PROVIDERS[selectedCountry] || 'uk-ob-all uk-oauth-all';
    if (isLocalHost) { providers = 'uk-cs-mock'; }
    const encodedProviders = providers.split(' ').map(encodeURIComponent).join('%20');
    const trueLayerUrl = `https://${baseUrl}/?response_type=code&client_id=${tlClientId}&scope=info%20accounts&redirect_uri=${strikeBaseUrl}/client/bank-callback&providers=${encodedProviders}&state=${selectedCountry}`;

    const onClickAddBankAccount = async() => {
        //Not awaiting here purposefully to allow user to not see 2nd Panel appearing(whenever possible)
        db.collection('clients').doc(clientId).update({
          trueLayerAttemptedAt: new Date(),
          updatedAt: new Date()
        });
      window.location.href = trueLayerUrl;
    }

    // Ensure initialValues includes country if bank doesn't have it
    const formInitialValues = bank || { country: "IE" };

    return (
      <Form
        {...FormItemLayout}
        form={form}
        name="bankRegister"
        initialValues={formInitialValues}
        scrollToFirstError
      >
        <div className="ant-row ant-form-item">
          <div className="ant-col ant-form-item-label ant-col-xs-24 ant-col-sm-8">
            <span className="" style={{ fontWeight: 500, fontSize: '15px' }}>Select the country of your bank</span>
          </div>
        </div>

        <Form.Item
          name="country"
          label="Country"
          rules={[
            {
              required: true,
              message: 'Please provide the country where the bank is located',
            },
          ]}
        >
          <Select
            placeholder="Select a country"
            onSelect={onSelectCountry}
          >
            {truelayerCountries.sort().map(countryCode => (
              <Option key={countryCode} value={countryCode}>
                {countryByCountryCode[countryCode]}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item {...TailFormItemLayout}>
          <p>Please add your bank account by pressing 'Add New Bank Account'. You'll be asked to
            authenticate with your bank and they will share your account details with us securely via TrueLayer.</p>
          <Button type="primary">
            <a onClick={() => onClickAddBankAccount()}>Add New Bank Account</a>
          </Button>
        </Form.Item>
      </Form>
    );
};
